import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	headingAutoUpgrade: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.heading-auto-upgrade',
		defaultMessage: 'You’ve been upgraded to Standard ',
		description:
			'Modal dialog heading that informs the user their Jira plan has been upgraded to Standard edition',
	},
	headingManualUpgrade: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.heading-manual-upgrade',
		defaultMessage: 'Welcome to {product}\u00A0Standard ',
		description:
			'Modal dialog heading that informs the user their Jira plan has been upgraded to Standard edition',
	},
	description: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.description',
		defaultMessage:
			'Your team has grown beyond the Free plan’s 3 agent limit, so you’ve been upgraded to the Standard plan.',
		description:
			'Modal dialog description that briefly explains why the user’s plan has been upgraded',
	},
	softwareAutoUpgradeDescription: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.software-auto-upgrade-description',
		defaultMessage:
			'Your team has grown beyond the Free plan’s 10 user limit, so you’ve been upgraded to the Standard plan.',
		description:
			'Modal dialog description that briefly explains why the user’s Jira plan has been upgraded',
	},
	softwareManualUpgradeDescription: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.software-manual-upgrade-description',
		defaultMessage: 'Your free 14-day trial of Jira Standard has started.',
		description:
			'Modal dialog description that briefly explains that the user’s Jira plan has been upgraded',
	},
	softwareManualUpgradeDescriptionSpork: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.software-manual-upgrade-description-spork',
		defaultMessage: 'Your free 14-day trial of Jira Standard has started.',
		description:
			'Modal dialog description that briefly explains that the user’s Jira plan has been upgraded',
	},
	serviceDeskAutoUpgradeDescription: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.service-desk-auto-upgrade-description',
		defaultMessage:
			'Your team has grown beyond the Free plan’s 3 agent limit, so you’ve been upgraded to the Standard plan.',
		description:
			'Modal dialog description that briefly explains why the user’s Jira Service Management plan has been upgraded',
	},
	serviceDeskManualUpgradeDescription: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.service-desk-manual-upgrade-description',
		defaultMessage: 'Your free 14-day trial of Jira Service Management Standard has started.',
		description:
			'Modal dialog description that briefly explains that the user’s Jira Service Management plan has been upgraded',
	},
	productDiscoveryAutoUpgradeDescription: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.product-discovery-auto-upgrade-description',
		defaultMessage:
			'Your team has grown beyond the Free plan’s 3 creator limit, so you’ve been upgraded to the Standard plan.',
		description:
			'Modal dialog description that briefly explains why the user’s Jira Product Discovery plan has been upgraded',
	},
	productDiscoveryManualUpgradeDescription: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.product-discovery-manual-upgrade-description',
		defaultMessage: 'Your free 14-day trial of Jira Product Discovery Standard has started.',
		description:
			'Modal dialog description that briefly explains that the user’s Jira Product Discovery plan has been upgraded',
	},
	later: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.later',
		defaultMessage: 'Later',
		description:
			'Text for button for dismissing a modal to inform the user their plan has been upgraded to Standard edition',
	},
	addPaymentDetails: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.add-payment-details',
		defaultMessage: 'Add payment details',
		description: 'Text for button for adding payment details',
	},
});
